export interface QuoteContent {
  quote: string;
  author: string;
  caption: string;
}
